import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const StyledTypography = styled(Typography)`
  max-width: 20rem;
`;

StyledTypography.displayName = 'StyledTypography';
